import type { BookStatus, EngineBand, PlanFit, TacticalStatus } from "../lessons/schema.ts";

const BOOK: Record<BookStatus, string> = {
  repertoire: "This is the course move in this position.",
  known: "This is a known sideline in this course.",
  warned: "The course warns against this move.",
  transposition: "This move order can rejoin a position the course covers.",
  novel: "This move is not in the course graph for this position.",
  unknown: "Book membership was not checked for this position.",
};

const ENGINE: Record<EngineBand, string> = {
  top: "The engine sees this as among the strongest tries here.",
  equivalent: "The engine sees this as roughly as strong as the top try.",
  playable: "The engine sees this as playable, with a real concession.",
  inferior: "The engine sees a clearly stronger alternative.",
  unknown: "Engine not checked.",
};

const PLAN: Record<PlanFit, string> = {
  advances: "This move advances the plan this course is teaching.",
  neutral: "This move does not fight the plan, but it is not the course idea.",
  conflicts: "This move fights the plan this course is teaching.",
  unknown: "Plan fit was not judged for this move.",
};

const RISK: Record<TacticalStatus, string> = {
  safe: "No large engine-evaluation drop at this limit.",
  questionable: "This looks risky — a tactic may be brewing.",
  losing: "This hangs into a tactic or a forced mate.",
  unknown: "Tactics were not checked.",
};

export function bookSentence(status: string, detail?: string): string {
  const key = status.toLowerCase();
  let base = BOOK.unknown;
  // "unknown" contains "known", so it is matched first.
  if (key.includes("unknown")) base = BOOK.unknown;
  else if (key.includes("repertoire")) base = BOOK.repertoire;
  else if (key.includes("transposition")) base = BOOK.transposition;
  else if (key.includes("warn")) base = BOOK.warned;
  else if (key.includes("known")) base = BOOK.known;
  else if (key.includes("novel")) base = BOOK.novel;
  else if (BOOK[status as BookStatus]) base = BOOK[status as BookStatus];
  return detail && detail !== status && !detail.toLowerCase().startsWith(key)
    ? `${base} ${detail}`
    : base;
}

export function engineSentence(band: string): string {
  return ENGINE[band as EngineBand] || (band === "Engine not checked" ? ENGINE.unknown : band);
}

export function planSentence(fit: string): string {
  return PLAN[fit as PlanFit] || fit;
}

export function riskSentence(status: string): string {
  return RISK[status as TacticalStatus] || status;
}
